module.exports = __webpack_public_path__ + "static/media/illuEuropraid2018_02_thumb_hover.4ef20e2b.png";